import type { Experiment, ExperimentTreatmentType } from '@ms/yammer-data/dist/state/types';
import { useEffect } from 'react';

import { useExperimentTreatmentWithoutReporting } from './selectors';
import { useReportExperimentTreatmentCallback } from './useReportExperimentTreatmentCallback';

type UseAndReportExperimentTreatment = <E extends Experiment>(experiment: E) => ExperimentTreatmentType<E>;
export const useAndReportExperimentTreatment: UseAndReportExperimentTreatment = (experiment) => {
  const treatment = useExperimentTreatmentWithoutReporting(experiment);
  const reportExperimentTreatmentCallback = useReportExperimentTreatmentCallback(experiment, treatment);

  useEffect(() => {
    reportExperimentTreatmentCallback();
  }, [experiment, treatment, reportExperimentTreatmentCallback]);

  return treatment;
};
